// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Search.css */
.table-container {
    display: flex;
    justify-content: center;
    overflow-x: auto;
    width: 100%;
}

.results {
    border-collapse: collapse;
    width: auto;
    border: 2px solid #00053E;
}

.results thead {
    background-color: #00053E;
    color: #FFC72C;
}

.results th {
    padding: 12px 24px;
    border: 1px solid #FFC72C;
    text-align: center;
    font-size: 1.25em;
}

.results tbody tr:nth-child(even) {
    background-color: #E6E6FA; /* Light purple for even rows */
}

.results tbody tr:nth-child(odd) {
    background-color: #FFFFFF; /* White for odd rows */
}

.results td {
    padding: 12px 24px;
    border: 1px solid #E6E6FA;
    text-align: center;
    color: #00053E;
    font-size: 1.25em;
}
`, "",{"version":3,"sources":["webpack://./src/components/search.css"],"names":[],"mappings":"AAAA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB,EAAE,+BAA+B;AAC9D;;AAEA;IACI,yBAAyB,EAAE,uBAAuB;AACtD;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,iBAAiB;AACrB","sourcesContent":["/* Search.css */\n.table-container {\n    display: flex;\n    justify-content: center;\n    overflow-x: auto;\n    width: 100%;\n}\n\n.results {\n    border-collapse: collapse;\n    width: auto;\n    border: 2px solid #00053E;\n}\n\n.results thead {\n    background-color: #00053E;\n    color: #FFC72C;\n}\n\n.results th {\n    padding: 12px 24px;\n    border: 1px solid #FFC72C;\n    text-align: center;\n    font-size: 1.25em;\n}\n\n.results tbody tr:nth-child(even) {\n    background-color: #E6E6FA; /* Light purple for even rows */\n}\n\n.results tbody tr:nth-child(odd) {\n    background-color: #FFFFFF; /* White for odd rows */\n}\n\n.results td {\n    padding: 12px 24px;\n    border: 1px solid #E6E6FA;\n    text-align: center;\n    color: #00053E;\n    font-size: 1.25em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
